import {Box, Card, Typography, CardProps} from '@mui/material';
import {FC, ReactNode} from 'react';
import {CardVariants} from './enums';
import OutlinedCard from '@jobseeker/lotus/components/Card/Outlined';

type MuiCardProps = Pick<CardProps, 'sx'>;
export interface Props extends MuiCardProps {
  variant: CardVariants | string;
  heading: String | ReactNode;
  body?: FC;
  icon?: ReactNode;
  children?: any;
}

let ComponentMap: {[key: string]: any} = {};
ComponentMap[CardVariants.OUTLINED] = OutlinedCard;

const Component = (props: Props) => {
  const MappedComponent = ComponentMap[props.variant];
  if (MappedComponent) return <MappedComponent {...props} />;
  else
    return (
      <Card
        sx={{borderRadius: '15px', p: '45px 40px', ...props.sx}}
        variant="elevation"
        elevation={3}
      >
        {props.icon && (
          <Box sx={{fontSize: '32px', color: 'primary.main', pb: 2}}>
            {props.icon}
          </Box>
        )}
        <Typography
          component={'p'}
          variant="body1"
          sx={{fontWeight: 'bold'}}
          className="heading"
        >
          {props.heading}
        </Typography>
        <Box>{props.children || props.body}</Box>
      </Card>
    );
};

Component.defaultProps = {
  heading: 'Place your heading here',
  // body: ,
  // icon: <FaBeer />
};

export default Component;
